import React, { useEffect, useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import NSMultiSelector from "../NSMultiSelector/NSMultiSelector";
import { isIPad13, isMobile } from "react-device-detect";
import { OptionsTecnicasFarmacos } from "../../helpers/Constants";
import { iconTecnicas } from "../../helpers/ImagesCache";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogTecnicasFarmacos = ({
  contexto,
  callbackConfirm,
  callbackCancel,
}) => {
  const T = useTranslation();
  const [tecnicas, setTecnicas] = useState(contexto.Tecnicas);
  const [farmacos, setFarmacos] = useState(contexto.Farmacos);

  useEffect(() => {
    setTecnicas(contexto.Tecnicas);
  }, [contexto.Tecnicas]);

  useEffect(() => {
    setFarmacos(contexto.Farmacos);
  }, [contexto.Farmacos]);

  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerSelect = () => {
    if (callbackConfirm) {
      callbackConfirm(farmacos, tecnicas);
    }
  };

  return (
    <>
      <FloatingDialog
        isOpen={true}
        onClose={handlerClose}
        variant={"bottom"}
        headerIcon={iconTecnicas}
        headerText={T("tecnicasFarmacos")}
      >
        <div className="flex flex-col h-full w-full">
          {/* Scrollable selector content */}
          <div className="flex-1 overflow-auto px-2">
            <div className="flex w-full min-w-0 pb-[15px] gap-2 items-start">
              <div className="text-sm flex flex-1 min-w-0 flex-col items-start justify-start">
                <span
                  style={{ fontSize: isMobile ? "18px" : "22px" }}
                  className="font-bold ml-4 mb-3"
                >
                  {T("Técnicas")}
                </span>
                <NSMultiSelector
                  options={OptionsTecnicasFarmacos[0]}
                  onCallBack={setTecnicas}
                  initial={contexto.Tecnicas}
                />
              </div>
              <div className="text-sm flex flex-1 min-w-0 flex-col items-start justify-start">
                <span
                  style={{ fontSize: isMobile ? "18px" : "22px" }}
                  className="font-bold ml-4 mb-3"
                >
                  {T("Fármacos")}
                </span>
                <NSMultiSelector
                  options={OptionsTecnicasFarmacos[1]}
                  onCallBack={setFarmacos}
                  initial={contexto.Farmacos}
                />
              </div>
            </div>
          </div>

          {/* Sticky footer button */}
          <div
            className="w-full pt-4 border-t border-gray-300"
            style={{
              marginBottom: isMobile ? "60px" : "0px",
            }}
          >
            <div className="flex justify-center items-center px-4">
              <SimpleButton text={T("saveAndReturn")} onClick={handlerSelect} />
            </div>
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogTecnicasFarmacos;

const styles = {
  saveContainer: {
    height: !isIPad13 ? "80px" : "80px",
    marginBottom: !isIPad13 ? "60px" : "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    background: "white",
    overflow: "hidden",
    width: "100%",
  },
  saveButton: {
    background: "#2aac9cff",
    color: "white",
    fontWeight: "bold",
  },
};
